import connect from '../axios/axios.auth';

const paquetesFunction =  {
  detalleGuia: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/detalle`, {data})
      .then((response) => {
        resolve(response);
      })
    })
  },
  registrarGuia : (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/`, {data})
      .then((response) => {
        resolve(response);
      })
    })
  },
  completaReserva : (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/complete-reserva`, {data})
      .then((response) => {
        resolve(response);
      })
    })
  },
  withMaster: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/master/paquetes`, { data })
      .then((response) => {
        resolve(response.data.list)
      })
    })
  },
  update: (data) => {
    return new Promise((resolve, reject) => {
      connect.put(`/master/`, { data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  listado: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/master/`)
      .then((response) => {
        resolve(response.data.list)
      })
    })
  },
}

export default paquetesFunction;